import React from 'react';

import ListCategorizedCampaigns from '../../campaigns/ListCategorizedCampaigns';
import Tabs from '../../generic/Tabs';
import ListCategorizedInvoices from '../../invoices/ListCategorizedInvoices';
import ListCategorizedOpportunities from '../../opportunities/ListCategorizedOpportunities';
import { sessionShape } from '../../prop-types';
import withSessionInfo from '../../signin/with-session-info';
import { SUBSCRIPTION } from '../constants';

const CollabaryDashboard = ({ session }) => {
  if (!(session && session.user)) return null;

  const tabs = () => {
    const campaignsView = (
      <ListCategorizedCampaigns title="" salesChannel={SUBSCRIPTION} />
    );

    const opportunitiesView = (
      <ListCategorizedOpportunities
        title=""
        salesChannel={SUBSCRIPTION}
        hiddenColumns={['Sales Channel']}
        showCreateLink={false}
      />
    );

    const invoicesView = (
      <ListCategorizedInvoices
        title=""
        salesChannel={SUBSCRIPTION}
        hiddenColumns={['Sales Channel']}
      />
    );

    return [
      {
        label: 'Invoices',
        value: 'invoices',
        content: invoicesView,
      },
      {
        label: 'Opportunities',
        value: 'opportunities',
        content: opportunitiesView,
      },
      {
        label: 'Campaigns',
        value: 'campaigns',
        content: campaignsView,
      },
    ];
  };
  return (
    <>
      <h2>Collabary</h2>
      <Tabs tabs={tabs()} defaultActive="invoices" id="collabaryDashboard" />;
    </>
  );
};

CollabaryDashboard.propTypes = {
  session: sessionShape,
};

CollabaryDashboard.defaultProps = {
  session: null,
};

export default withSessionInfo(CollabaryDashboard);
